export class AcquisitionSourceBase {
  public id: string;
  public active: boolean;
  public name: string;
  public notes: string;
  public show_in_portal: boolean;
}
